// extracted by mini-css-extract-plugin
export default {"title":"MyEventsHomeList_title__31dR2"};